var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex flex-align-center"},[_c('div',{class:['state_icon', _vm.stateClass.status]}),_c('div',{staticClass:"ml-10"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row.status_txt)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }